export default from './notification-list-item';



// WEBPACK FOOTER //
// ./app/components/notification-list-item/index.js